import { Injectable } from '@angular/core';
import { DroplistItem, PageTabsLayoutPageService } from '@eforall/dashboard';


/**
 * The list of tabs on this page
 */
export enum AdmissionsManagerPageTabId {
	Manager = 1,
	Tab1 = 2,
	Tab2 = 3,
}

/**
 * The list if main tab droplist views on this page
 */
export enum AdmissionsManagerPageViewId {
	Status = 1,
	TrimesterSwitchover = 2,
	ApplStatusFlow = 3,
}


@Injectable({ providedIn: 'root' })
export class AdmissionsManagerService extends PageTabsLayoutPageService<AdmissionsManagerPageTabId, AdmissionsManagerPageViewId> {

	private static readonly _viewDroplistItems: DroplistItem<never, AdmissionsManagerPageViewId>[] = [{
		uniqueId: AdmissionsManagerPageViewId.Status,
		iconContext: {
			iconClass: 'fa-grip-horizontal',
			iconStyle: 'fa-solid',
			text: 'Status',
			hideText: 'never',
		},
		customSort: '1-Manager-1'
	},
	{
		uniqueId: AdmissionsManagerPageViewId.TrimesterSwitchover,
		iconContext: {
			iconClass: 'fa-calendar',
			iconStyle: 'fa-solid',
			text: 'Trimester Switchover',
			hideText: 'never',
		},
		customSort: '1-Manager-2'
	},
	{
		uniqueId: AdmissionsManagerPageViewId.ApplStatusFlow,
		iconContext: {
			iconClass: 'fa-calendar',
			iconStyle: 'fa-solid',
			text: 'Application Status Flow',
			hideText: 'never',
		},
		customSort: '1-Manager-3'
	}
	];

	constructor() {
		super(AdmissionsManagerService._viewDroplistItems, AdmissionsManagerService.name, AdmissionsManagerPageTabId.Manager, AdmissionsManagerPageViewId.Status);
	}

	public get viewId() {
		return AdmissionsManagerPageViewId;
	}

}